import { render, staticRenderFns } from "./distribution-page.vue?vue&type=template&id=4cfe2fa7"
import script from "./distribution-page.vue?vue&type=script&lang=js"
export * from "./distribution-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cfe2fa7')) {
      api.createRecord('4cfe2fa7', component.options)
    } else {
      api.reload('4cfe2fa7', component.options)
    }
    module.hot.accept("./distribution-page.vue?vue&type=template&id=4cfe2fa7", function () {
      api.rerender('4cfe2fa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/distribution-page.vue"
export default component.exports